import { render, staticRenderFns } from "./emptyBox.vue?vue&type=template&id=6c640096&"
import script from "./emptyBox.vue?vue&type=script&lang=js&"
export * from "./emptyBox.vue?vue&type=script&lang=js&"
import style0 from "./emptyBox.vue?vue&type=style&index=0&id=6c640096&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports